import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

//Components
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { Button } from 'devextreme-react';

import ActionProgress from './../shared/ActionProgress';


// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
});



const DialogTitle = withStyles(styles)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});


const DialogContent = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
}))(MuiDialogActions);

class GestioneStatoLicenzaCmp extends Component {

    constructor(props) {
        super(props);

        this.submitState = this.submitState.bind(this); 
        this.clearAll = this.clearAll.bind(this);
    }

    submitState() {
        const { selected_license, codiceUtente, blockLicense, unblockLicense, showGestioneStatoDialog } = this.props;

        showGestioneStatoDialog();

        if (selected_license.Bloccata === 'true')
            unblockLicense(selected_license.ProductKey, codiceUtente);
        else if (selected_license.Bloccata === 'false')
            blockLicense(selected_license.ProductKey, codiceUtente);
    }

    // dopo aver completato la modifica, faccio reset e refresh della griglia licenze
    clearAll() {
        this.props.refreshLicenses(this.props.codiceUtente);
        this.props.resetFilters();
    }


    render() {
        const { classes, selected_license, codiceUtente, isOpen, blockLicense, unblockLicense,
            showGestioneStatoDialog, manageStateLicenseRequestStatus, manageStateLicenseErrorMessage } = this.props;

        return (
            <Fragment>
                <Dialog
                    onClose={showGestioneStatoDialog}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                >
                    <DialogTitle id="customized-dialog-title" onClose={showGestioneStatoDialog}>
                        Gestione stato
                </DialogTitle>
                    <DialogContent dividers>
                        <Typography gutterBottom >
                            Confermi di voler {selected_license.Bloccata === 'true' ? 'sbloccare' : 'bloccare'} la licenza selezionata?
                        </Typography>
                    </DialogContent>
                    <DialogActions className={classes.alignCenter}>
                        {selected_license.Bloccata === 'true' ?
                            <Button
                                width={120}
                                text="Sblocca"
                                type="success"
                                stylingMode="contained"
                                onClick={() => this.submitState()}
                            />
                            :
                            <Button
                                width={120}
                                text="Blocca"
                                type="danger"
                                stylingMode="contained"
                                onClick={() => this.submitState()}
                            />
                        }
                    </DialogActions>
                </Dialog>

                <ActionProgress
                    status={manageStateLicenseRequestStatus}
                    errorMessage={manageStateLicenseErrorMessage}
                    tryAgainAction={
                        selected_license.Bloccata === 'true' ?
                            () => unblockLicense(selected_license.ProductKey, codiceUtente)
                            :
                            () => blockLicense(selected_license.ProductKey, codiceUtente)
                    }
                    afterResolvedAction={() => this.clearAll()}
                />
            </ Fragment>
        );

    }
}

GestioneStatoLicenzaCmp.propTypes = {
    blockLicense: PropTypes.func.isRequired,
    unblockLicense: PropTypes.func.isRequired,

    manageStateLicenseRequestStatus: PropTypes.string.isRequired,
    manageStateLicenseErrorMessage: PropTypes.string,

    selected_license: PropTypes.shape({}),

    showGestioneStatoDialog: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(GestioneStatoLicenzaCmp);